import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import FormMixin from '@/amui-fe/mixins/formMixin';
let AmFeDateRangePickerField = class AmFeDateRangePickerField extends Mixins(FormMixin) {
  get dateFormat() {
    switch (this.type) {
      case 'daterange':
        // 日期区间
        return 'yyyy-MM-dd';
      case 'monthrange':
        // 月区间
        return 'yyyy-MM';
      case 'datetimerange':
        // 日期时间区间
        return 'yyyy-MM-dd HH:mm';
      default:
        return '';
    }
  }
  get dateValueFormat() {
    if (this.valueFormat == 'yyyy-MM-dd') {
      return this.dateFormat;
    } else {
      return this.valueFormat;
    }
  }
  get label_i18n() {
    return this.label === '日期区间' ? window.lowcode.i18n.get('apaas_amui_daterangepickerfield_label', '日期区间') : this.label;
  }
};
AmFeDateRangePickerField.componentName = 'AmFeDateRangePickerField';
__decorate([Prop({
  default: 'daterange'
})], AmFeDateRangePickerField.prototype, "type", void 0);
__decorate([Prop({
  default: () => {
    return window.lowcode.i18n.get('apaas_amui_daterangepickerfield_placeholderstart', '开始日期');
  }
})], AmFeDateRangePickerField.prototype, "startPlaceholder", void 0);
__decorate([Prop({
  default: () => {
    return window.lowcode.i18n.get('apaas_amui_daterangepickerfield_placeholderend', '结束日期');
  }
})], AmFeDateRangePickerField.prototype, "endPlaceholder", void 0);
__decorate([Prop({
  default: 'yyyy-MM-dd'
})], AmFeDateRangePickerField.prototype, "format", void 0);
__decorate([Prop({
  default: 'yyyy-MM-dd'
})], AmFeDateRangePickerField.prototype, "valueFormat", void 0);
__decorate([Prop({
  default: false
})], AmFeDateRangePickerField.prototype, "clearable", void 0);
AmFeDateRangePickerField = __decorate([Component({
  name: 'AmFeDateRangePickerField'
})], AmFeDateRangePickerField);
export default AmFeDateRangePickerField;